<template>
    <b-modal
        id="add-internships-modal"
        ref="add-internships-modal"
        size="lg"
        :title="$t('group.show.add_internships')"
        modal-class="apprentice-default-modal add-internships"
        cancel-variant="outline-primary"
        :cancel-title="$t('common.cancel')"
        :ok-title="$t('common.add')"
        @ok="onOk"
        @show="load()">
        <div class="internship-add-form">
            <div class="description">
                <p>
                    {{ $t('internships.filter_by_internship_duration_or_internship_type') }}
                </p>
            </div>

            <b-alert
                v-if="errorsFound"
                variant="danger"
                show>
                {{ errorMessage }}
            </b-alert>

            <b-form-group
                class="internship-duration-tags-group"
                label-for="internship-duration-tags-input"
                :label="$t('group.show.selection_internship_duration')">
                <design-2021-apprentice-multiselect-component
                    v-model="durationTags"
                    :placeholder="$t('group.show.choose_internship_duration')"
                    :allow-empty="true"
                    label="name"
                    :options="internshipDurationTagsComputed"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>

            <b-form-group
                class="internship-tags-group"
                label-for="internship-tags-input"
                :label="$t('group.show.per_internship_type')">
                <design-2021-apprentice-multiselect-component
                    v-model="tags"
                    :placeholder="$t('internships.choose_internship_type')"
                    :allow-empty="true"
                    label="name"
                    :options="internshipTagsComputed"
                    track-by="id">
                </design-2021-apprentice-multiselect-component>
            </b-form-group>
            <br />
            <p v-if="excludedInternships.length">
                {{ $t('internships.filter_by_internship_duration_or_internship_type') }}
            </p>
            <design-2021-apprentice-data-table
                v-if="excludedInternships.length"
                :items="excludedInternships"
                :fields="internshipFields"
                :show-empty="true">
                <template v-slot:cell(action)="data">
                    <div class="management-actions">
                        <b-button
                            class="btn-add"
                            v-b-tooltip.hover
                            variant="primary-icon-only"
                            :title="$t('internships.restore')"
                            @click="reincludeInternship(data.item.id)">
                        </b-button>
                    </div>
                </template>
            </design-2021-apprentice-data-table>
        </div>
    </b-modal>
</template>

<script>
export default {
    name: 'design-2021-group-add-internships-modal-component',
    props: ['groupIn', 'excludedInternshipsIn'],
    data() {
        return {
            excludedInternships: this.excludedInternshipsIn,
            internships: [],
            internshipTags: [],
            internshipDurationTags: [],
            tags: this.groupIn.internship_tags ? this.groupIn.internship_tags : [],
            durationTags: this.groupIn.internship_duration_tags ? this.groupIn.internship_duration_tags : [],
            loaded: false,
            errorsFound: false,
            errorMessage: '',
            internshipFields: [
                {
                    key: 'name',
                    label: this.$t('common.name'),
                },
                {
                    key: 'location',
                    label: this.$t('common.city'),
                },
                {
                    key: 'organization',
                    label: this.$t('common.organization'),
                },
                {
                    key: 'action',
                    label: this.$t('common.actions'),
                },
            ],
        };
    },
    computed: {
        internshipTagsComputed() {
            return this.internshipTags.map((tag) => {
                tag.name = tag.name + ' (' + tag.internships.length + ')';
                return tag;
            });
        },
        internshipDurationTagsComputed() {
            return this.internshipDurationTags.map((tag) => {
                tag.name = tag.name + ' (' + tag.internships.length + ')';
                return tag;
            });
        },
    },
    methods: {
        onOk() {
            this.alert.saving();

            let durationTagArray = this.durationTags.map((tag) => tag.id);
            let tagArray = this.tags.map((tag) => tag.id);
            const data = {
                durationTags: durationTagArray,
                tags: tagArray,
            };
            this.axios.post(this.routes.groupInternshipAddToGroup(this.groupIn.id), data).then(
                (response) => {
                    this.$emit('addInternships', response.data);
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        getData() {
            this.axios.get(this.routes.groupGetInternshipsForSchool()).then(
                (response) => {
                    this.internships = response.data.internships;
                    this.internshipTags = response.data.internshipTags;
                    this.internshipDurationTags = response.data.internshipDurationTags;
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        load() {
            this.excludedInternships = this.excludedInternshipsIn;
            if (!this.loaded) {
                this.getData();
                this.loaded = true;
            }
        },
        reincludeInternship(id) {
            let data = {
                internship_id: id,
                group_id: this.groupIn.id,
            };

            this.axios.delete(this.routes.excludeInternshipFromGroup(this.groupIn.id), { data }).then(
                (response) => {
                    const internshipToReinclude = this.excludedInternships.find((internship) => internship.id === id);
                    this.excludedInternships = this.excludedInternships.filter((internship) => internship.id !== id);
                    this.$emit('reinclude-internship', internshipToReinclude);
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
    },
};
</script>

<style scoped lang="scss">
.internship-tags-group,
.internships-group {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.duplicate-info {
    font-weight: $font-weight-medium;
    color: $text-muted-color;
    text-align: right;
}

.description {
    font-weight: $font-weight-medium;
    color: $text-muted-color;
    font-size: $base-font-size;
    line-height: 1.5;
    margin-bottom: map-get($grid-gutter-spacing, 'forty-two');
}

.internship-duration-tags-group {
    margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
}

.internship-add-zipcode-group ::v-deep {
    .btn {
        &:before {
            margin-right: 0;
        }
    }
}

@media (min-width: map-get($grid-breakpoints, 'lg')) {
    .internship-add-form ::v-deep {
        .apprentice-table-header {
            flex-direction: row;

            .apprentice-table-filters {
                flex: 1 0 auto;
            }

            .apprentice-data-table-actions {
                flex: 0 0 auto;
                margin-bottom: map-get($grid-gutter-spacing, 'ten');
            }
        }
    }

    .internship-postal-codes-group {
        margin-left: auto;
        margin-bottom: 0;
    }
}

@media (min-width: map-get($grid-breakpoints, 'xl')) {
    .internship-add-form ::v-deep {
        .apprentice-table-header {
            .apprentice-data-table-actions {
                margin-bottom: 0;
            }
        }
    }
}
</style>
